/* !
 * technology.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const path = window.location.pathname;

	const technologyNewsList = () => {
	    const jsonFiles = [
	        '/ajax/technology/presentations/presentations.json',
	        '/ajax/eng/technology/presentations/presentations.json',
	        '/ajax/cn/technology/presentations/presentations.json'
	    ];

	    const categoryClassMap = {
	        'メッシュ': '_col1',
	        'Mesh Cloth': '_col1',
	        '纱网': '_col1',

	        '抗微生物': '_col2',
	        'Anti Microbial': '_col2',

	        '触媒': '_col3',
	        '催化剂': '_col3',
	        'Catalyst': '_col3'
	    };

	    const insertNewsItems = (data, language, isDefault) => {

	        if (data.rt_bn_news_list.length) {
	            const anchorList = document.querySelector('.js-technologyAnchor');
	            const technologyList = document.querySelector('.js-technologyList');

	            let yearMap = new Map();
	            let count = 1;  // カウントを初期化

	            // 年ごとにデータをマップに整理
	            data.rt_bn_news_list.forEach(val => {
	                let year = new Date(val.cf_n_date).getFullYear();
	                if (!yearMap.has(year)) {
	                    yearMap.set(year, []);
	                }
	                yearMap.get(year).push(val);
	            });

	            // 年を降順にソートして処理
	            const sortedYears = Array.from(yearMap.keys()).sort((a, b) => b - a);

	            sortedYears.forEach(year => {
	                const newsList = yearMap.get(year);
	                const sortedNewsList = yearMap.get(year).sort((a, b) => new Date(b.cf_n_date) - new Date(a.cf_n_date));

	                // <li>部分のHTMLを作成
	                let liHTML = `
	                <li>
	                    <a href="#0${count}" rel="ajaxScroll">
	                        <svg aria-hidden="true">
	                            <use xlink:href="/common/svg/sprite.svg#arrow_bottom"></use>
	                        </svg><span class="td_under">${year}年</span>
	                    </a>
	                </li>`;
	                if(anchorList) {
	                	anchorList.insertAdjacentHTML('beforeend', liHTML); // アンカーリンクのリストに追加
	                }

	                // <div>部分のHTMLを作成
	                let divHTML = `
	                <div class="mod-spacer-section" id="0${count}">
	                    <div class="mod-auto">
	                        <h3 class="mod-head03 __border"><span>${year}年</span></h3>
	                    </div>
	                    <ul class="technology-presentations-list mod-auto mod-spacer_30">`;

	                sortedNewsList.forEach(val => {
	                    let categoryName = isDefault ? val.cf_n_category.cf_nc_name : val.cf_n_category[`cf_nc_name_${language}`];
	                    let categoryClass = categoryClassMap[categoryName] || '';

	                    divHTML += `<li>
	                        <span class="technology-presentations-list-tag ${categoryClass}">${categoryName}</span>
	                        <div>
	                            <p class="technology-presentations-list-title">${val[`cf_n_title_${language}`]}</p>`;

	                    if (val[`cf_n_remarks_${language}`]) {
	                        divHTML += `<p class="technology-presentations-list-subTitle">${val[`cf_n_remarks_${language}`]}</p>`;
	                    }

	                    divHTML += `</div></li>`;
	                });

	                divHTML += `</ul></div>`;

	                if(technologyList) {
	                	technologyList.insertAdjacentHTML('beforeend', divHTML); // HTMLを挿入
	                }
	                count++;  // カウントをインクリメント
	            });
	            const scrollToObject = (_self) => {
					let hash = _self.currentTarget.href.split('#')[1];
					let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
					let offset = hash === 'pagetop' ? 0 : window.scrollY;
					pos += offset;

					if (hash !== 'pagetop') {
						if (window.innerWidth < 768) {
							pos = pos - 84;
						} else {
							pos = pos - 100;
						}
					}

		        	if (window.innerWidth <= 1024) {
				        pos -= 10;
				    } else {
				        pos -= 20;
				    }

					window.scrollTo({ top: pos, behavior: 'smooth' });
				}
				// フォーカス用関数
				const scrollFocus = (_hash) => {
					let hash = _hash;
					if (hash !== 'pagetop') {
						const focusableElementsSelector = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';
						const focusableElements = Array.from(
							document.getElementById(hash).querySelectorAll(focusableElementsSelector)
						);
						if(focusableElements.length) {
							focusableElements[0].focus({ preventScroll: true });
						}
					}
				};
				// スクロール完了後に実行する関数
				let scrollResolveTimeout;
				const waitForScrollComplete = (_hash) => {
				  return new Promise((resolve) => {
					const scrollTimeout = setTimeout(() => {
					  resolve(true);
					}, 100);
					const scrollTimeoutEvent = addEventListener('scroll', function fn (e) {
						clearTimeout(scrollTimeout);
						clearTimeout(scrollResolveTimeout);
						scrollResolveTimeout = setTimeout(function () {
							scrollFocus(_hash);
							removeEventListener('scroll', fn);
							resolve(true);
						}, 100);
					});
				  });
				};
				document.querySelectorAll('a[rel="ajaxScroll"]').forEach((ele) => {
					console.log("test");
					ele.addEventListener('click', async (e) => {
						e.preventDefault();
						if (/#/.test(e.currentTarget.href)) {
							scrollToObject(e);
							let hash = e.currentTarget.href.split('#')[1];
							await waitForScrollComplete(hash);
							return false;
						}
					});
				});
	        }
	    };

	    const fetchAndInsertNewsItems = (url, language, isDefault) => {
	        fetch(url)
	            .then(response => response.json())
	            .then(data => insertNewsItems(data, language, isDefault))
	            .catch(error => console.error("データ取得エラー:", error));
	    };

	    const currentURL = window.location.href;
	    let selectedFile;
	    let language;
	    let isDefault = false;

	    if (currentURL.includes('/eng/')) {
	        selectedFile = jsonFiles[1];
	        language = 'en';
	    } else if (currentURL.includes('/cn/')) {
	        selectedFile = jsonFiles[2];
	        language = 'cn';
	    } else {
	        selectedFile = jsonFiles[0];
	        language = 'jp';
	        isDefault = true;
	    }

	    fetchAndInsertNewsItems(selectedFile, language, isDefault);
	};

	window.addEventListener('DOMContentLoaded', technologyNewsList);

	const displayCategoryCounts = () => {
		function addCategoriesToSelect() {
			// カテゴリ情報の取得
			let categoryElements = document.querySelectorAll('[data-view="pc,tablet"] .rt_bn_news_category_list');
			let totalCountElement = document.querySelector('[data-view="pc,tablet"] .rt_bn_news_list_all_total');
			let totalCount = 0;
			if (totalCountElement) {
				totalCount = parseInt(totalCountElement.textContent.trim());
			}
			
			// セレクトボックスに「すべて」オプションを追加
			let selectElement = document.getElementById('input_pref');
			let allOption = document.createElement('option');
			allOption.value = '/technology/column/'; // 「すべて」の場合のURL
			allOption.textContent = 'すべて（' + totalCount + '）';
			selectElement.appendChild(allOption);
			
			// 各カテゴリのオプションを追加
			categoryElements.forEach(function(element) {
				let categoryLink = element.querySelector('.rt_n_category_url');
				let categoryName = element.querySelector('.rt_bc_category_total').textContent.trim().split('（')[0];
				let categoryCount = parseInt(element.querySelector('.rt_bc_category_total').textContent.trim().split('（')[1].split('）')[0]);
				let categoryURL = categoryLink.getAttribute('href');
				
				let option = document.createElement('option');
				option.value = categoryURL;
				option.textContent = categoryName + '（' + categoryCount + '）';
				selectElement.appendChild(option);

				// valueとURLが一致する場合に、そのオプションを選択状態にする
				if (window.location.pathname === categoryURL) {
					option.selected = true;
				}
			});
		}

		// セレクトボックスの値が変更されたときに遷移させる関数
		function navigateToSelectedCategory() {
			let selectElement = document.getElementById('input_pref');
			let selectedValue = selectElement.value;
			if (selectedValue) {
				window.location.href = selectedValue; // 選択されたカテゴリのURLに遷移
			}
		}

		// SP表示時のカテゴリ別出力処理を実行
		addCategoriesToSelect();

		// セレクトボックスの値が変更されたときに遷移させるイベントを追加
		document.getElementById('input_pref').addEventListener('change', navigateToSelectedCategory);
	}
	window.addEventListener('DOMContentLoaded', displayCategoryCounts);

	const currentURL = window.location.pathname;

    // 1. /technology/column/ のリンクをチェック
	const mainLink = document.querySelector('.mod-link_text[href="/technology/column/"], .mod-link_text[href="/eng/technology/column/"], .mod-link_text[href="/cn/technology/column/"]');
	if (mainLink) {
	    const mainSpan = mainLink.querySelector('.rt_bc_category_total');
	    if (mainSpan) {
	        if (currentURL === '/technology/column/' || currentURL === '/eng/technology/column/' || currentURL === '/cn/technology/column/') {
	            mainSpan.classList.add('fw_bold');
	        } else {
	            mainSpan.classList.add('td_under');
	        }
	    }
	}

    // 2. rt_bn_news_category_list 内のリンクをチェック
    const categoryLinks = document.querySelectorAll('.rt_bn_news_category_list .mod-link_text');
    categoryLinks.forEach(link => {
        const span = link.querySelector('.rt_bc_category_total');
        if (span) {
            if (link.pathname === currentURL) {
                span.classList.add('fw_bold');
            } else {
                span.classList.add('td_under');
            }
        }
    });

	// 用語集作成
	let keyList = [
		"head",
		"initial",
		"title",
		"category1",
		"category2",
		"category3",
		"category4",
		"category5",
		"description",
		"url1",
		"url2",
		"imgFilePath"
	];

	// csv読み込み
	const loadCSV = () => {
		async function loadCSVData() {
			const response = await fetch('glossary.csv');
			const text = await response.text();
			const data = text.trim().split('\n').map(line => line.split(',').map(x => x.trim()));

			createObj(data);
		}
		loadCSVData();
	}

	// csv object化
	const createObj = (data) => {
		const resultObj = data.filter((_, index) => index !== 0).map((line) => {
			const tmpObj = {};
			keyList.map((key, index) => (tmpObj[key] = line[index]));
			return tmpObj;
		});

		// console.log("obj",resultObj);
		createTabContents(resultObj)
	}

	// タブ,コンテンツ作成
	const createTabContents = (data) => {
		let headArr = data.map((obj) => obj.head);
		// console.log(headArr,'1');
		// 重複削除
		headArr = [...new Set(headArr)];
		// 昇順でソート
		headArr.sort();
		// console.log(headArr,'2');

		// csv行分タブを作成
		let fragment = new DocumentFragment();
		let fragment2 = new DocumentFragment();
		let fragment3 = new DocumentFragment();
		headArr.forEach((head,i) => {
			// console.log(head,i)
			// tab
			let tab = document.createElement('div');
			tab.className = "mod-tab-item js-tab";
			if(i === 0) tab.classList.add(a);
			tab.dataset.target = `tabContent${i+1}`;
			tab.innerText = (head !== "英数字") ? `${head}行` : `${head}`;
			fragment.append(tab);

			// tabSelect > option
			let option = document.createElement('option');
			option.innerText = (head !== "英数字") ? `${head}行` : `${head}`;
			option.value = `tabContent${i+1}`;
			if(i === 0) option.selected = true;
			fragment2.append(option);

			// tabContent
			let tabContent = document.createElement('div');
			tabContent.className = "mod-tab js-tab-content";
			if(i === 0) tabContent.classList.add(a,v);
			tabContent.dataset.target = `tabContent${i+1}`;
			fragment3.append(tabContent);
		});
		let parentnode = document.getElementsByClassName('mod-tab-btns')[0];
		let parentnode2 = document.getElementsByClassName('js-tab-select')[0];
		let parentnode3 = document.getElementsByClassName('js-tab-content-wrap')[0];
		parentnode.append(fragment);
		parentnode2.append(fragment2);
		parentnode3.append(fragment3);

		// タブボタンにイベント登録
		FUNCTIONS.tabSwitch();

		createArticle(data,headArr)
	}

	// アンカーリンク・記事作成
	const createArticle = (data,headArr) => {
		let initialCnt = 0;
		headArr.forEach((head,i) => {
			// console.log(head)
			// 行内の頭文字を配列化
			let filterArr = data.filter(obj => obj.head === head);
			let initialArr = filterArr.map((obj) => obj.initial);
			initialArr = [...new Set(initialArr)];
			// 昇順でソート
			initialArr.sort();

			// 挿入するタブコンテンツ
			let wrap = document.querySelector([`.js-tab-content[data-target="tabContent${i+1}"]`]);

			// アンカーリンク作成
			let ulElm = document.createElement('ul');
			let linkTemp = document.getElementById("js-template-glossary-link").content;
			let linkTempRight = document.getElementById("js-template-glossary-link_right").content;
			let linkBlankTemp = document.getElementById("js-template-glossary-link-blank").content;
			ulElm.className = "mod-anchorLink";

			initialArr.forEach((initial,i) => {
				initialCnt++;
				// アンカーリンク中身作成
				let liElm = document.createElement('li');				
				let linkClone = document.importNode(linkTemp, true);
				linkClone.querySelector("a").href = `#${('000' + initialCnt ).slice( -3 )}`;
				linkClone.querySelector("a").rel = "scroll"
				linkClone.querySelector("span").textContent = initial;
				liElm.append(linkClone);
				ulElm.append(liElm);

				// 記事枠・タイトル・記事作成

				// 記事枠作成
				let divElm = document.createElement('div');
				divElm.className = "mod-spacer-section";

				// タイトル作成
				let h3Elm =  document.createElement('h3');
				h3Elm.id = `${('000' + initialCnt ).slice( -3 )}`;
				h3Elm.className = "mod-head03 __border";
				h3Elm.textContent = `「${initial}」で始まる用語`;
				divElm.append(h3Elm);

				// 記事作成
				let articleArr = data.filter(obj => obj.initial === initial);
				// 昇順でソート
				articleArr.sort((a, b) => a.title.localeCompare(b.title));
				console.log(articleArr,'articleArr');
				articleArr.forEach((article,ii) => {
					let articleElm = document.createElement('div');
					articleElm.className = (ii === 0) ? "mod-spacer_30" : "mod-spacer_50";

					let column1Temp = document.getElementById("js-template-glossary-column1").content;
					let column2Temp = document.getElementById("js-template-glossary-column2").content;
					let columnClone;
					// 画像の有無でテンプレート切り替え
					if(article.imgFilePath === "") {
						columnClone = document.importNode(column1Temp, true);
					} else {
						columnClone = document.importNode(column2Temp, true);
						columnClone.querySelector(".__column_img img").src = article.imgFilePath;
					}

					// 記事タイトル
					columnClone.querySelector("h4").textContent = article.title;

					// タグ
					[article.category1,article.category2,article.category3,article.category4,article.category5].forEach(category => {
						if(category !== "") {
							let tagElm = document.createElement('span');
							tagElm.className = "webinars-tag col4";
							tagElm.textContent = category;
							columnClone.querySelector(".webinars-box1-tags").append(tagElm);
						}
					});

					// 説明
					article.description = article.description.replace(/\(改行\)/g,`<br>`)
					columnClone.querySelector(".js-article-description").innerHTML = article.description;

					// リンク
					let articleLinkUlElm = document.createElement('ul');
					articleLinkUlElm.className = "mt20";
					if((article.url1 !== "") || (article.url2 !== "")) {
						[article.url1,article.url2].forEach((url,iii) => {
							if(url !== "") {
								let articleLinkLiElm = document.createElement('li');
								let linkClone;
								if(checkHostname(url)) {
									linkClone = document.importNode(linkTempRight, true);
								} else {
									linkClone = document.importNode(linkBlankTemp, true);
									linkClone.querySelector("a").className = "__blank";
								}
								linkClone.querySelector("a").classList.add("mod-link01");
								if(iii >= 1) {
									linkClone.querySelector("a").classList.add("mt10");
								}
								linkClone.querySelector(".td_under").textContent = "関連するページへのリンク";

								linkClone.querySelector("a").href = url;
								articleLinkLiElm.append(linkClone);
								articleLinkUlElm.append(articleLinkLiElm);
							}
						});

						columnClone.querySelector(".js-article-description").after(articleLinkUlElm)
					}

					articleElm.append(columnClone);
					divElm.append(articleElm);
				});

				wrap.append(divElm);
			});

			// アンカーリンクを最初に挿入
			wrap.insertBefore(ulElm, wrap.firstChild);
		});

		// アンカーリンクにイベント登録
		FUNCTIONS.easeScroll();
	}

	// 外部リンク判定
	const checkHostname = (uri) => {
		if(uri.indexOf("http") == -1) return true;
		let _uri = new URL(uri);
		return "www.nbc-jp.com" ===  _uri.hostname;
	}

	if(document.querySelector(".js-glossary-article")) {
		loadCSV();
	}
})(window.FUNCTIONS);
